<template>
  <button class="gradient-button" :disabled="disabled" @click="onClick">
    {{ props.label }}

    <slot />
  </button>
</template>

<script setup>
const props = defineProps({
  label: {
    type: String,
    required: true
  },
  disabled: {
    type: Boolean,
    default: () => false
  },
  onClick: {
    type: Function,
    required: true
  }
});
</script>

<style lang="scss">
.gradient-button {
  background: linear-gradient(to bottom, #f7ab06, #591500);
  color: white;
  font-weight: 600;
  font-size: 20px;
  padding: 0 55px;
  border: 2px solid white;
  border-radius: 9999px;
  cursor: pointer;
  outline: none;
  transition:
    transform 0.1s ease,
    box-shadow 0.2s ease;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
  max-width: fit-content;
  margin: 0 auto;
  font-family: Eczar, sans-serif;
  height: 62px;
  white-space: nowrap;

  &:disabled {
    opacity: 0.7;
    pointer-events: none;
    background: #a2a2a2;
    color: #000;
    border: 2px solid #fff;
    text-shadow: none;
  }
}

.gradient-button:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.gradient-button:active {
  transform: scale(0.98);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}
</style>
